export const ADMIN_SCREENING_FORM = "admin_screening";
export const PAGE_COUNT = 100;
